export { default as useFetch } from './useFetch';
export * from './useFetch';
//# sourceMappingURL=index.js.map